import axios, { CancelToken } from 'axios'
import { FileToUpload } from './types'

async function uploadFile(file: FileToUpload, cancelToken: CancelToken) {
  let fd = new FormData()
  fd.append('file', file.file)
  return axios.post(`/v1/user/files/${file.fileId}`, fd, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    cancelToken: cancelToken,
  })
}

export { uploadFile }
